module.exports = __webpack_public_path__ + "img/circle-arrow-down-left.1bf23b49.svg";